import { useAdditionalMailingsQuery } from "src/store/additionalMailing";

export function useAdditionalMailingCounts() {
  const { data: pendingApproval } = useAdditionalMailingsQuery({
    tab: "pending_approval",
    limit: 1,
  });
  const { data: recentlyApproved } = useAdditionalMailingsQuery({
    tab: "recently_approved",
    limit: 1,
  });
  const { data: historical } = useAdditionalMailingsQuery({
    tab: "historical",
    limit: 1,
  });

  return {
    pendingApproval: pendingApproval?.count ?? 0,
    recentlyApproved: recentlyApproved?.count ?? 0,
    historical: historical?.count ?? 0,
  };
}
